<script lang="ts">
    import RoutePointMarkFinishedIndicator from './RoutePointMarkFinishedIndicator.svelte';
    import { type ReorderedRouteType } from '../AssignmentApi';
    import type { DisplayShapeType } from './types';

    export let displayShape: DisplayShapeType;
    export let value: string = '1';
    export let isWarehouse: boolean = false;
    export let isApproached: boolean = false;
    export let isCompleted: boolean = false;
    export let isNotConfirmed: boolean = false;
    export let isCurrent: boolean = false;

    $: console.log('RoutePointMark', displayShape, value, isWarehouse, isApproached, isCompleted);
</script>

<div class="div-block">
    {#if displayShape === 'multi-first'}
        <div class="s1_bullet" class:s1_bullet_color={isNotConfirmed}>
            <RoutePointMarkFinishedIndicator {value} {isApproached} {isCompleted} />
        </div>
        <div class="s1_bullet_group s1_bullet_group_first"></div>
        <div class="s_route_group_line s_route_group_line_down"></div>
    {:else if displayShape === 'multi-middle'}
        <div class="s1_bullet" class:s1_bullet_color={isNotConfirmed}></div>
        <div class="s1_bullet_group s1_bullet_group_middle"></div>
        <div class="s_route_group_line s_route_group_line_up"></div>
        <div class="s_route_group_line s_route_group_line_down"></div>
    {:else if displayShape === 'multi-last'}
        <div class="s1_bullet" class:s1_bullet_color={isNotConfirmed}></div>
        <div class="s1_bullet_group s1_bullet_group_last"></div>
        <div class="s_route_group_line s_route_group_line_up"></div>
    {:else if displayShape === 'multi-collapsed'}
        <div class="s1_bullet" class:s1_bullet_color={isNotConfirmed} class:s1_bullet_current={isCurrent}>
            <RoutePointMarkFinishedIndicator {value} {isApproached} {isCompleted} />
        </div>
        <div class="s1_bullet_group s1_bullet_group_collapsed"></div>
    {:else if displayShape === 'single-first'}
        <div class="s1_bullet" class:s1_bullet_color={isNotConfirmed} class:s1_bullet_current={isCurrent} class:isWarehouse>
            <RoutePointMarkFinishedIndicator {value} {isApproached} {isCompleted} />
        </div>
        <div class="s_route_line s_route_line_down"></div>
    {:else if displayShape === 'single-middle'}
        <div class="s1_bullet" class:s1_bullet_color={isNotConfirmed} class:s1_bullet_current={isCurrent} class:isWarehouse>
            <RoutePointMarkFinishedIndicator {value} {isApproached} {isCompleted} />
        </div>
        <div class="s_route_line s_route_line_up"></div>
        <div class="s_route_line s_route_line_down"></div>
    {:else if displayShape === 'single-last'}
        <div class="s1_bullet" class:s1_bullet_color={isNotConfirmed} class:s1_bullet_current={isCurrent} class:isWarehouse>
            <RoutePointMarkFinishedIndicator {value} {isApproached} {isCompleted} />
        </div>
        <div class="s_route_line s_route_line_up"></div>
    {:else}
        <div class="s1_bullet"></div>
    {/if}
</div>

<style>
    .div-block {
        align-items: center;
        display: flex;
        position: relative;
        overflow: hidden;
        justify-content: center;
        /*min-height: 34px;*/
        min-height: 36px;
        min-width: 34px;
    }
    .s1_bullet {
        z-index: 5;
        color: #fff;
        background-color: #000;
        border: 2px solid #fff;
        border-radius: 15px;
        justify-content: center;
        align-items: center;
        width: 26px;
        height: 26px;
        /*margin-right: 8px;*/
        /*padding-left: 6px;*/
        /*padding-right: 6px;*/
        font-size: 12px;
        display: flex;
    }
    .s1_bullet_current {
        background-color: #4b76de;
    }
    .s1_bullet_color {
        background-color: #f05555;
        border: 3px solid #222;
        width: 22px;
        height: 22px;
    }
    .isWarehouse {
        background-color: #fff;
        border: 1px solid #222;
        width: 24px;
        height: 24px;
        color: black;
    }
    .s1_bullet_group {
        z-index: 3;
        background-color: #fff;
        border: 3px solid #000;
        border-radius: 20px;
        width: 32px;
        height: 102px;
        position: absolute;
        left: 1px;
    }
    .s1_bullet_group_first {
        top: 2px;
    }
    .s1_bullet_group_last {
        top: -68px;
    }
    .s1_bullet_group_middle {
        top: -39px;
    }
    .s1_bullet_group_collapsed {
        height: 32px;
    }
    /*.s_route_line {*/
    /*    z-index: 2;*/
    /*    border: 2px solid #000;*/
    /*    width: 0;*/
    /*    position: absolute;*/
    /*    left: 15px;*/
    /*    height: 30px;*/
    /*}*/
    .s_route_line_up {
        top: 0;
    }
    .s_route_line_down {
        height: 20px;
        top: 30px;
    }

    .s_route_group_line {
        z-index: 4;
        border: 2px dotted #000;
        width: 0;
        height: 20px;
        position: absolute;
        left: 15px;
    }
    .s_route_group_line_up {
        top: 0;
    }
    .s_route_group_line_down {
        height: 30px;
        top: 10px;
    }
</style>
